// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed } from '@ember/object';
import Service, { service } from '@ember/service';
import config from 'garaje/config/environment';
import type CookieAuthService from 'garaje/services/cookie-auth';
import type MetricsService from 'garaje/services/metrics';
import type SessionService from 'garaje/services/session';
import $ from 'jquery';

export default class CsvAjaxService extends Service {
  @service declare cookieAuth: CookieAuthService;
  @service declare metrics: MetricsService;
  @service declare session: SessionService;

  trustedHosts = config.trustedHosts;

  @computed('session.{data.authenticated.access_token,isAuthenticated}')
  get headers(): Record<string, string> {
    const headers: Record<string, string> = { Accept: 'application/vnd.api+json' };

    if (this.session.isAuthenticated) {
      headers['Authorization'] = `Bearer ${this.session.data.authenticated['access_token']}`;
      headers['X-Envoy-Context'] = JSON.stringify(this.metrics.getEnvoyContext());
    }

    return headers;
  }

  request(url: string, settings: { type: string }): Promise<string> {
    const headers = this.headers;

    const mandatorySettings = {
      url,
      type: 'GET',
      contentType: 'text/csv',
      headers,
    };

    settings = Object.assign({}, settings, mandatorySettings);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, ember/no-jquery, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    return $.ajax(this.cookieAuth.jQueryDecorator(url, settings.type, settings));
  }
}
